export const SET_FIRST_CATEGORIES = 'SET_FIRST_CATEGORIES'
export const SET_SECOND_CATEGORIES = 'SET_SECOND_CATEGORIES'
export const RESET_SECOND_CATEGORIES = 'RESET_SECOND_CATEGORIES'



// WEBPACK FOOTER //
// ./src/store/modules/category/types.js